import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { i18next } from '@frontend/i18n';
import { getOnboardingCallLink } from '../../../self-upgrade.util';

export const ONLINE_SCHEDULING_VIDEO_URL = 'https://fast.wistia.com/embed/medias/xa4iqfutw1';
export const ONLINE_SCHEDULING_PRICE = 49;
export const ONLINE_SCHEDULING_ONBOARDING_URL = getOnboardingCallLink(Feature.ONLINE_SCHEDULING);
export const ONLINE_SCHEDULING_FEATURE_NAME = i18next.t('Online Scheduling', { ns: 'featurePromotion>>feature' });
